export default {
  // Navigation
  nav: {
    home: "Accueil",
    contact: "Contact",
    admin: "Administration",
    form: "Formulaire",
  },

  // Header
  header: {
    eventPeriod: "Du 05 juillet au 31 août 2025",
  },

  // Page d'accueil
  home: {
    title: "Bienvenue à l'Aéroport Toulouse-Blagnac",
    subtitle: "Votre portail vers le monde",
    description: "Découvrez nos services et informations pour votre voyage",
    participate: "JE PARTICIPE",
    participateTitle: "INSCRIVEZ-VOUS",
    itsVerySimple: "ET GAGNEZ",
    fillCoordinates: "Remplissez vos coordonnées",
    discoverGift: "Découvrez votre cadeau",
    retrieveGift: "Récupérer votre cadeau ou profitez de votre offre dans l'une des boutiques de l'aéroport",
    gameWinning: "JEU 100% GAGNANT !",
    toWin: "À GAGNER",
    travel: "un voyage",
    wirelessHeadphones: "des écouteurs sans fil",
    vouchersAndGifts: "des bons d'achat et plein d'autres cadeaux",
    participationSimple: "POUR PARTICIPER C'EST TRÈS SIMPLE,",
    gifts: "DES CADEAUX !",
  },

  // Formulaire
  form: {
    loading: "Chargement en cours...",
    title: "Formulaire de réservation",
    submit: "Soumettre",
    cancel: "Annuler",
    required: "Ce champ est requis",
    email: "Adresse e-mail",
    name: "Nom complet",
    phone: "Téléphone",
    message: "Message",
    fillForm: "RENSEIGNEZ VOTRE E-MAIL POUR",
    discoverGain: "DÉCOUVRIR VOTRE CADEAU",
    pleaseWait: "Veuillez patienter",
    requiredFields: "*Champs obligatoire",
    privacyNotice:
      "Les données personnelles transmises par les participants font l'objet d'un traitement informatique pour les besoins de la gestion du jeu et sont destinées à la société Aéroport Toulouse-Blagnac. Conformément à la loi « informatique et libertés » du 6 janvier 1978, modifiée en 2004, et au Règlement Général sur la Protection des Données (« RGPD »), vous bénéficiez d'un droit d'accès, de rectification, d'effacement et de portabilité des données collectées, et d'un droit d'opposition au traitement ou à sa limitation.",
    invalidEmail:
      "Votre email est un email temporaire, contenant un +, ou invalide.",
  },

  // Contact
  contact: {
    title: "Contactez-nous",
    address: "Adresse",
    phone: "Téléphone",
    email: "E-mail",
    sendMessage: "Envoyer un message",
    pageTitle: "CONTACTEZ NOUS",
    lastName: "Votre nom*",
    firstName: "Votre prénom*",
    emailAddress: "Votre adresse email*",
    requestType: "Type de demande*",
    subject: "Objet*",
    message: "Message*",
    chooseOption: "Choisissez une option",
    technicalIssue: "Problème technique lors de ma participation",
    siteNotWorking: "Le site du jeu ne fonctionne pas",
    gameInfo: "Demande d'information sur le jeu",
    other: "Autre",
    requiredFields: "*Champs obligatoires",
    send: "ENVOYER",
    loading: "Chargement...",
    fieldRequired: "Ce champ est requis",
  },

  // Administration
  admin: {
    title: "Administration",
    dashboard: "Tableau de bord",
    users: "Utilisateurs",
    settings: "Paramètres",
    fillForm: "RENSEIGNEZ LE CODE ",
    discoverGain: "POUR VÉRIFIER SA VALIDITÉ",
    pleaseWait: "Veuillez patienter",
    ticketAddedSuccess: "TICKET DE CAISSE AJOUTER AVEC SUCCÈS !",
    clickToAddAnother:
      "Cliquez sur le bouton ci-dessous pour entrer un nouveau code",
    requiredFields: "*Champs obligatoire",
    privacyNotice:
      "Les données personnelles transmises par les participants font l'objet d'un traitement informatique pour les besoins de la gestion du jeu et sont destinées à la société Aéroport Toulouse-Blagnac Conformément à la loi « informatique et libertés » du 6 janvier 1978, modifiée en 2004, et au Règlement Général sur la Protection des Données (« RGPD »), vous bénéficiez d'un droit d'accès, de rectification, d'effacement et de portabilité des données collectées, et d'un droit d'opposition au traitement ou à sa limitation.",
    uniqueCode: "Code unique",
    invalidCode: "Code invalide ou déjà utilisé",
    verify: "VÉRIFIER",
    errorOccurred: "Une erreur est survenue, veuillez réessayer.",
    pleaseEnterCode: "Veuillez saisir un code",
    invalidEmailMessage: "Votre email est un email temporaire, contenant un +, ou invalide.",
  },

  // Messages généraux
  common: {
    loading: "Chargement...",
    error: "Une erreur est survenue",
    success: "Opération réussie",
    confirm: "Confirmer",
    delete: "Supprimer",
    edit: "Modifier",
    save: "Enregistrer",
    close: "Fermer",
    back: "retour",
  },

  // Game Over
  gameover: {
    title: "Jeu terminé",
    subtitle: "Merci d'avoir participé !",
    thanksMessage: "Nous espérons que vous avez apprécié cette expérience.",
    comeBackMessage: "Revenez bientôt pour de nouvelles opportunités de gagner des cadeaux !",
    backToHome: "Retour à l'accueil",
    contactUs: "Nous contacter",
    eventPeriod: "Événement du 05 juillet au 31 août 2025",
  },

  // Footer
  footer: {
    rules: "Règlement",
    legalNotice: "Mentions légales",
    privacyPolicy: "Politique de confidentialité",
    cookies: "Cookies",
    contactUs: "Nous contacter",
    slogan: "Shopping & Service : Vibrez, Partagez, vivez Toulouse !",
  },

  // Lots et récompenses
  lots: {
    congratulations: "BRAVO !",
    youWin: "VOUS REMPORTEZ",
    voucher5: "UN BON D'ACHAT<br>DE 5 € TTC",
    voucher15: "UN BON D'ACHAT<br>DE 15 € TTC",
    voucherCondition: "pour tout achat de 20 € TTC minimum hors tabac et alcool dans les boutiques Relay ou restaurants de l'aérogare",
    voucher15Condition: "pour tout achat de 50 € TTC minimum hors tabac et alcool dans l'une des boutiques de l'aérogare",
    howToBenefit: "COMMENT BÉNÉFICIER DE VOTRE DOTATION ?",
    findConfirmation: "<b class=\"not-italic\">RETROUVEZ</b> la confirmation de votre gain dans l'e-mail envoyé sur l'adresse renseignée lors de votre inscription",
    findConfirmationVoyage: "<b class=\"not-italic\">RETROUVEZ</b> la confirmation de votre gain dans l'e-mail envoyé sur l'adresse renseignée lors de votre inscription. Vérifiez vos spams !",
    goToShop: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans les restaurants et boutiques Relay de l’aérogare et faites vos achats",
    goToShop2: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans l’un(e) des boutiques et restaurants de l’aérogare",
    goToShopAirpods: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans vos boutiques Relay / Stade Toulousain / Fnac ou Relay / Monop' Daily / Fnac de l'aérogare où un employé vous remettra votre dotation sur présentation de votre e-mail de confirmation",
    goToShopPanier: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans votre boutique Relay / Stade Toulousain / Fnac de l'aérogare où un employé vous remettra votre dotation sur présentation de votre e-mail de confirmation",
    goToShopGeneral: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans l'une des boutiques de l'aérogare",
    goToShopBr15: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans l'une des boutiques de l'aérogare et faites vos achats",
    sendCoordinates: "<b class=\"not-italic\">RENVOYEZ</b> vos coordonnées (nom, prénom et numéro de téléphone), nous vous recontacterons.",
    enjoyGift: "<b class=\"not-italic\">PROFITEZ</b> de votre cadeau",
    enjoyGiftExclamation: "<b class=\"not-italic\">PROFITEZ</b> de votre cadeau !",
    enjoyGift2: "<b class=\"not-italic\">PROFITEZ</b> de votre cadeau",
    enjoyGiftExclamation2: "<b class=\"not-italic\">PROFITEZ</b> de votre cadeau !",
    enjoyVoucher: "<b class=\"not-italic\">PROFITEZ</b> de votre bon d'achat sur présentation de votre e-mail de confirmation en caisse",
    enjoyTrip: "<b class=\"not-italic\">PROFITEZ</b> de votre séjour !",
    enjoyVoucherBr15: "<b class=\"not-italic\">PROFITEZ</b> de votre bon d'achat sur présentation de votre e-mail de confirmation en caisse",
    warning: "Attention: votre gain est valable aujourd'hui jusqu'à 23h59. Passé ce délai, il sera considéré perdu et la dotation sera remise en jeu.",
    
    // Noms des lots
    planeTickets: "DES BILLETS D'AVION*",
    fan: "UN ÉVENTAIL !",
    wirelessHeadphones: "DES ÉCOUTEURS<br>SANS FIL JBL TUNE FLEX",
    giftBasket: "UN PANIER GARNI<br>DE CADEAUX",
    beachBall: "UN BALLON DE<br>PLAGE !",
    
    // Texte pour les conditions spéciales
    seeRules: "*Voir règlement de l'opération",
    giftBasketOrigin: "issus des boutiques de l'aéroport de<br>Toulouse-Blagnac",
  },

  // Page de fin de jeu
  perd: {
    sorry: "DÉSOLÉ",
    gameOver: "LE JEU EST TERMINÉ",
    thanksForParticipating: "Merci d'avoir participé !",
  },
};
